import { render, staticRenderFns } from "./DemographicsTemplate.vue?vue&type=template&id=7f6ee2ae"
import script from "./DemographicsTemplate.vue?vue&type=script&lang=js"
export * from "./DemographicsTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports